import { render } from "./Bio.vue?vue&type=template&id=08812792&scoped=true"
const script = {}

import "./Bio.vue?vue&type=style&index=0&id=08812792&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08812792"]])

export default __exports__